import gql from "graphql-tag";

export const REMOVE_BACKLOG_GROUP = gql`
  mutation removeBacklogGroup($input: removeBacklogGroupInput) {
    removeBacklogGroup(input: $input) {
      _id
    }
  }
`;
